import React, { useRef, useLayoutEffect } from 'react';

const useEnhanceExpand = ({ maxShowPixels = 300, videoRef, isLastElementVideo = null, device = 'desktop' }) => {
  const GRADIENT_HEIGHTS = {
    desktop: 200,
    mobile: 128,
  };

  const GRADIENT_HEIGHT = GRADIENT_HEIGHTS[device] || GRADIENT_HEIGHTS.desktop;
  const expandableRef = useRef(null);

  const [isExpanded, setIsExpanded] = React.useState(false);

  useLayoutEffect(() => {
    const { current } = expandableRef;

    if (current?.clientHeight <= maxShowPixels) {
      setIsExpanded(true);
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.intersectionRatio > 0 && entry.intersectionRatio < 1) {
          if (isLastElementVideo) {
            setIsExpanded(true);
            return;
          }
          const missingPixels =
            entry.boundingClientRect.height - entry.boundingClientRect.height * entry.intersectionRatio;

          current.style.maxHeight = `${maxShowPixels + missingPixels + GRADIENT_HEIGHT}px`;
          current.style.overflow = 'hidden';
        }
      },
      {
        root: current,
        rootMargin: '0px',
        threshold: 1,
      },
    );

    if (videoRef?.current) {
      observer.observe(videoRef.current);
    }

    current.style.maxHeight = `${maxShowPixels}px`;
    current.style.overflow = 'hidden';

    if (isExpanded) {
      expandableRef.current.style.maxHeight = '100%';
    }
  }, [videoRef, GRADIENT_HEIGHT, isLastElementVideo, maxShowPixels, isExpanded]);

  const expandContent = () => setIsExpanded(true);

  return {
    isExpanded,
    expandableRef,
    expandContent,
  };
};

export default useEnhanceExpand;
